import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'

import {BASE_CLASS_NAME} from '../../config.js'

const CardSelection = ({unCommonData, vehicle}) => {
  const {i18n} = useContext(Context)

  const {version, bodyType, doors, fuelType, transmissionType} = vehicle

  const title = version.split(' ').slice(0, 4).join(' ')

  const vehicleSpecs = [{label: i18n.t('COMMON.VERSION'), value: version}]

  if (unCommonData.bodyType || unCommonData.doors)
    vehicleSpecs.push({
      label: i18n.t('COMMON.PLURALS.BODY_TYPE', 1),
      value: i18n.t('TECHNICAL_DETAILS_BODY_TYPE_DOORS_TAG', {
        bodyType,
        doors
      })
    })

  if (unCommonData.fuelType || unCommonData.fuelTypeId)
    vehicleSpecs.push({
      label: i18n.t('COMMON.FUEL'),
      value: fuelType
    })

  if (unCommonData.transmissionType || unCommonData.transmissionTypeId)
    vehicleSpecs.push({
      label: i18n.t('COMMON.TRANSMISSION'),
      value: transmissionType
    })

  return (
    <div className={`${BASE_CLASS_NAME}-vehicleSelection-card`}>
      <p className={`${BASE_CLASS_NAME}-vehicleSelection-cardTitle`}>{title}</p>
      {vehicleSpecs.map(({label, value}) => (
        <p className={`${BASE_CLASS_NAME}-vehicleSelection-cardSpec`} key={`${label}-${value}`}>
          <span className={`${BASE_CLASS_NAME}-vehicleSelection-cardLabel`}>{`${label}: `}</span>
          {value}
        </p>
      ))}
    </div>
  )
}

CardSelection.displayName = 'CardSelection'

CardSelection.propTypes = {
  unCommonData: PropTypes.object.isRequired,
  vehicle: PropTypes.object.isRequired
}

export default CardSelection
